import { UntypedFormGroup } from '@angular/forms';

export abstract class ValueMatchValidator {
  static equal(field1: string, field2: string) {
    return (group: UntypedFormGroup): { [key: string]: any } | null => {
      if (!group || !group.controls) {
        return null;
      }

      const control1 = group.controls[field1];
      const control2 = group.controls[field2];

      const value1 = control1.value;
      const value2 = control2.value;
      return !control1.dirty || !control2.dirty || value1 === value2 ? null : { equalFieldValues: { valid: false } };
    };
  }
}
